<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img class="Form__thank_img" src="assets/img/thank.png" alt="ok">
          <p class="Form__tx _ft-cnt">
            お名前の変更が完了しました。
          </p>
          <router-link
            class="Btn__blue Btn__blue--lg Form__btn--mt_md Form__btn--mt_sp_sm"
            to="/change"
          >
            登録情報変更ページに戻る
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'ChangeNameThanks'
}
</script>
